/**
 * Wat de microfoon binnenkrijgt, als een rij staafjes.
 *
 * Niet om mooi te zijn: dit is het antwoord op "neemt hij mij wel op". Een
 * meter die niets doet terwijl er wordt gepraat betekent dat de verkeerde
 * microfoon aan staat, en dat wil je binnen tien seconden weten en niet na
 * drie kwartier.
 */
const STAAFJES = 16;

export function Niveaumeter({ niveau }: { niveau: number }) {
  return (
    <div aria-hidden className="flex h-10 w-full items-end gap-[3px]">
      {Array.from({ length: STAAFJES }, (_, i) => {
        // Een vaste vorm over de rij, zodat het een golf lijkt en niet een
        // blokkendoos die als geheel op en neer gaat.
        const vorm = 0.45 + 0.55 * Math.sin(((i + 1) / STAAFJES) * Math.PI);
        const hoogte = Math.max(8, Math.min(100, niveau * vorm * 160));
        return (
          <span
            className="flex-grow rounded-[2px] transition-[height] duration-100"
            key={i}
            style={{
              height: `${hoogte}%`,
              backgroundColor: hoogte > 55 ? 'var(--vs-sky-700)' : 'var(--vs-sky)',
            }}
          />
        );
      })}
    </div>
  );
}
